import type { CommsCampaign } from './interfaces';
import { SELF_SERVICE_COMMS_CAMPAIGN_TEMPLATE } from './selfServiceCommsCampaignTemplate';

// Treat the organisation name as text inside the stored email/SMS rich-text bodies.
function escapeProviderName(name: string): string {
    return name.replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}

// Create independent template messages only for a named self-service organisation.
export function createDefaultCommsCampaignMessages(provider: {
    commercialModel?: string;
    name?: string;
}): CommsCampaign['messages'] {
    if (provider.commercialModel !== 'self_service') {
        return [];
    }
    const providerName = provider.name?.trim();
    if (!providerName) {
        throw new Error('A provider name is required to create the default communications campaign.');
    }

    const escapedName = escapeProviderName(providerName);
    return SELF_SERVICE_COMMS_CAMPAIGN_TEMPLATE.map((message) => {
        // Literal replacement preserves dollar characters in names instead of treating them as replacement tokens.
        const text = message.text.split('$PROVIDER_NAME').join(escapedName);
        return {
            ...message,
            stages: [...message.stages],
            channels: [...message.channels],
            // Mark plain stored SMS as HTML so the editor and sender decode escaped names consistently.
            text: /<\/?[a-z][\s\S]*>/i.test(message.text) ? text : `<span>${text}</span>`,
        };
    });
}
